import { FormattedMessage } from "react-intl"
import { NavLink, Route, Routes } from "react-router"
import IframeResizer from "iframe-resizer-react"
import { DefaultUserMenu } from "@rio-cloud/rio-user-menu-component"
import ApplicationLayout from "@rio-cloud/rio-uikit/ApplicationLayout"
import ApplicationHeader from "@rio-cloud/rio-uikit/ApplicationHeader"

import { config } from "@/configuration/app/app-config"
import { routingConfig } from "@/components/Application/RoutingConfig"
import { SelectedTransportOrderSidebar } from "@/components/RioAdmin/SelectedTransportOrderSidebar"
import { TransportOrders } from "@/components/RioAdmin/TransportOrders"

const appNavigator = config.appMenuFrontend.url ? (
    <div className='iframe-wrapper'>
        <IframeResizer title='Admin Menu' src={config.appMenuFrontend.url} sizeWidth={true} scrolling className='iFrameResizer' />
    </div>
) : undefined

export const AdminApplication = () => {

    const navItems = []

    const defaultUserMenu = (
        <DefaultUserMenu environment={config.mode} key="userMenu"/>
    )

    return (
        <ApplicationLayout className={"printable-content"}>
            <ApplicationLayout.Header>
                <ApplicationHeader
                    label={<><FormattedMessage id={"application.name"}/>{" Admin"}</>}
                    homeRoute={<NavLink to={routingConfig.rioAdminTransportOrders.path} />}
                    appNavigator={appNavigator}
                    navItems={navItems}
                    actionBarItems={[defaultUserMenu]}
                />
            </ApplicationLayout.Header>
            <SelectedTransportOrderSidebar />
            <ApplicationLayout.Body>
                <Routes>
                    <Route index element={<TransportOrders/>}/>
                </Routes>
            </ApplicationLayout.Body>
        </ApplicationLayout>
    )
}
